import React, { useCallback, useMemo } from 'react';
import { Icon } from '../icon';
import { RatingLabel } from './rating-label';
import style from './styles.module.css';
export const RatingLayout = ({
  value,
  labelVariant = 'default',
  children,
  color
}) => {
  const validRating = useMemo(() => {
    if (value > 0) {
      return value < 5 ? +value.toFixed(1) : 5;
    }

    return 0;
  }, [value]);
  const offsetX = useCallback(starValue => {
    if (starValue > 0) {
      return starValue < 1 ? -8 : 0;
    }

    return -16;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style.starsWrap
  }, [...Array(5).keys()].map(item => {
    const starValue = validRating - item;
    return /*#__PURE__*/React.createElement(Icon, {
      className: style.starButton,
      key: item,
      color: color || 'brand-primary'
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.248 5.57474L16 6.09684L11.64 10.08L12.944 16L8 12.8589L3.056 16L4.368 10.08L0 6.09684L5.752 5.58316L8 0L10.248 5.57474ZM5.79174 9.59207L4.99174 13.1963L7.99974 11.2847L11.0157 13.2047L10.2157 9.60049L12.8717 7.17523L9.36774 6.85523L7.99974 3.45312L6.63974 6.84681L3.13574 7.16681L5.79174 9.59207Z"
    }), /*#__PURE__*/React.createElement("clipPath", {
      id: "clip"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M8 12.8589L12.944 16L11.632 10.08L16 6.09684L10.248 5.58316L8 0L5.752 5.58316L0 6.09684L4.368 10.08L3.056 16L8 12.8589Z"
    })), /*#__PURE__*/React.createElement("rect", {
      "data-testid": `rating-star-${item}`,
      clipPath: "url(#clip)",
      width: 16,
      height: 16,
      x: offsetX(starValue)
    })));
  })), labelVariant && /*#__PURE__*/React.createElement(RatingLabel, {
    labelVariant: labelVariant
  }, children));
};